import { useMemo } from 'react';
import { GridColumn } from 'src/components/GridWrapper';
import { BlindReceivePermissions } from 'src/constants/permissionsList';
import usePermission from 'src/hooks/usePermissions';

export const useReceiptLineItemColumns = () => {
  const isBlindReceive = usePermission({ permissions: BlindReceivePermissions });

  const receiptLineItemColumns: GridColumn<any>[] = useMemo(
    () => [
      ...(isBlindReceive
        ? []
        : ([
            {
              field: 'poQty',
              title: 'PO Qty',
              filter: 'numeric',
              dataType: 'number',
              filterFormat: '#',
              step: 1,
            },
            {
              field: 'currentDocQty',
              title: 'Current Receipt Qty',
              filter: 'numeric',
              dataType: 'number',
              filterFormat: '#',
              step: 1,
            },
          ] as GridColumn<any>[])),

      {
        field: 'item',
        title: 'Item #',
        filter: 'text',
        dataType: 'string',
      },
      {
        field: 'itemDescription',
        title: 'Description',
        filter: 'text',
        dataType: 'string',
      },
      {
        field: 'poglCode',
        title: 'GL Code',
        filter: 'text',
        dataType: 'string',
      },
      {
        field: 'uom',
        title: 'UOM',
        filter: 'text',
        dataType: 'string',
      },
    ],
    [isBlindReceive]
  );
  return receiptLineItemColumns;
};

export default useReceiptLineItemColumns;
